angular.module('NumbersEditor').controller('PublishResultsController', [
    '$scope', '$routeParams', '$rootScope', 'EventFactory', '$filter', 'GameFactory', '$location', '$route',
    function ($scope, $routeParams, $rootScope, eventFactory, $filter, gameFactory, $location, $route) {

        function getSubTitle() {
            var sportCode = $routeParams.sportCode === "49" ? "49" : "Irish Lottery";
            var eventNo = parseInt($routeParams.no);
            var draw = "";
            if (sportCode === "49" && eventNo === 1)
                draw = "Lunch Time";
            else if (sportCode === "49" && eventNo === 2)
                draw = "Tea Time";
            var date = $filter("date")($routeParams.startDate, "fullDate");

            return sportCode + " - " + draw + " - (" + date + ")";
        }

        function init() {
            $scope.RandomResultChallenge = {
                ChallengeOneDrawPosition: "",
                ChallengeOneDrawResult: "",
                ChallengeTwoDrawPosition: "",
                ChallengeTwoDrawResult: "",
                ChallengeThreeDrawPosition: "",
                ChallengeThreeDrawResult: ""
            };

            eventFactory.GetDrawApprovalDto($routeParams.eventId)
                .success(function (drawApproval) {
                    $scope.RandomResultChallenge.ChallengeOneDrawPosition = drawApproval.RandomResults[0];
                    $scope.RandomResultChallenge.ChallengeTwoDrawPosition = drawApproval.RandomResults[1];
                    $scope.RandomResultChallenge.ChallengeThreeDrawPosition = drawApproval.RandomResults[2];

                    $scope.DrawApproval = drawApproval;
                    $scope.CanPublish = $scope.DrawApproval.IsPublished === false && ($scope.DrawApproval.SisApproved && $scope.DrawApproval.AdjudicatorApproved);
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };

        $rootScope.SetAppTitle("Publish Result", getSubTitle());

        init();

        $scope.SiSTechApprove = function () {
            gameFactory.SiSTechApprove($routeParams.gameId)
                .success(function (result) {
                    $scope.DrawApproval.SisApproved = result;
                    $scope.CanPublish = $scope.DrawApproval.SisApproved && $scope.DrawApproval.AdjudicatorApproved;
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };

        $scope.AdjudicatorApprove = function () {
            gameFactory.AdjudicatorApprove($routeParams.gameId)
                .success(function (result) {
                    $scope.DrawApproval.AdjudicatorApproved = result;
                    $scope.CanPublish = $scope.DrawApproval.SisApproved && $scope.DrawApproval.AdjudicatorApproved;
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };

        $scope.PublishResult = function () {
            eventFactory.PublishResultWithRandomResultChallenge($routeParams.eventId, $scope.RandomResultChallenge)
                .success(function () {
                    $.message(MessageText.ResultSuccessfullyPublished, MessageType.Success);
                    $route.reload();
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };

        $scope.BackToDraw = function () {
            $location.path("event/" + $routeParams.eventId).search({ sportCode: $routeParams.sportCode, startDate: $routeParams.startDate, gameId: $routeParams.gameId, no: $routeParams.no });
        };

        $scope.GoToPostDrawBallWeight = function () {
            $location.path("postdrawweight/" + $routeParams.eventId).search({ sportCode: $routeParams.sportCode, startDate: $routeParams.startDate, gameId: $routeParams.gameId, no: $routeParams.no });
        }
    }
]);